var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFramer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 80,
    viewBox: "0 0 82 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Framer"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 80,
    rx: 15,
    fill: "#185AF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 518",
    d: "M22.0371 13.5039H59.4496V32.3073H40.915L59.4496 50.7689H40.8288V69.5723L22.0371 50.7689V32.3073H40.915L22.0371 13.5039Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFramer);
export default __webpack_public_path__ + "static/media/Framer.a4ce1138a177f3a119cdad719ec5024c.svg";
export { ForwardRef as ReactComponent };